// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "2e9fb43f" + "." + "333ee5a4eaa61fec" + ".js";
};